var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9832 7.0641V0.0951793C17.7744 0.258769 18.5039 0.632051 19.09 1.19867L23.4518 5.40441C24.0379 5.96954 24.4266 6.67297 24.5963 7.4359H17.3687C17.1559 7.4359 16.9832 7.26933 16.9832 7.0641ZM24.695 9.66667V24.9103C24.695 27.1663 22.7932 29 20.4535 29H5.02983C2.69006 29 0.78833 27.1663 0.78833 24.9103V4.08974C0.78833 1.83369 2.69006 0 5.02983 0H14.6696V7.0641C14.6696 8.49923 15.8804 9.66667 17.3687 9.66667H24.695ZM13.8984 21.9359C13.8984 21.3202 13.3802 20.8205 12.7416 20.8205H8.11456C7.47602 20.8205 6.95779 21.3202 6.95779 21.9359C6.95779 22.5516 7.47602 23.0513 8.11456 23.0513H12.7416C13.3802 23.0513 13.8984 22.5516 13.8984 21.9359ZM18.5255 17.4744C18.5255 16.8587 18.0073 16.359 17.3687 16.359H8.11456C7.47602 16.359 6.95779 16.8587 6.95779 17.4744C6.95779 18.0901 7.47602 18.5897 8.11456 18.5897H17.3687C18.0073 18.5897 18.5255 18.0901 18.5255 17.4744ZM18.5255 13.0128C18.5255 12.3971 18.0073 11.8974 17.3687 11.8974H8.11456C7.47602 11.8974 6.95779 12.3971 6.95779 13.0128C6.95779 13.6285 7.47602 14.1282 8.11456 14.1282H17.3687C18.0073 14.1282 18.5255 13.6285 18.5255 13.0128Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d10535b39b480d710ca06c96b9d1f721.svg";
export { ForwardRef as ReactComponent };